import React from "react";
import Home from "./pages/Auth/home";
import CompanyProfile from "./pages/Profile/companyProfile";
import LandingCostCalculator from "./pages/LandingCostCalculator/landingCostCalculator";
import MyDocuments from "./pages/Documents/myDocuments";
import Header from "./components/header";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Dashboard from "./pages/DashBoard/dashboard";
import CapacityListing from "./pages/Profile/capacityListing/capacityListing";
import UnAuthorizedPage from "./pages/Auth/unAuthorizedPage";
import { useSelector } from "react-redux";
import EditProfile from "./pages/Auth/MyProfile/editProfile";
import Contact from "./pages/Contact/contact";
import AboutUs from "./pages/AboutUs/aboutUs";
import Faqs from "./pages/FAQs/faqs";
import BidsReceive from "./pages/DashBoard/bidsReceive";
import consumerDashboard from "./pages/DashBoard/consumerDashboard";
import GNAAnalysisDashboard from "./pages/Analyst/Dashboard/dashboard";
import GNAAnalysisEditProfile from "./pages/Analyst/Profile/viewUserProfile";
import GNACapacityListing from "./pages/Analyst/Capacity/gnaCapacityListing";
import ViewUserProfile from "./pages/Analyst/Profile/viewUserProfile";
import VerifyYourAccount from "./pages/Auth/verifyYourAccount";
import OTPVerification from "./pages/Auth/OTPVerification";
import CapacityListingNew from "./pages/Profile/capacityListingNew/capacityListingNew";
import ResetPassword from "./pages/Auth/resetPassword";
import PasswordResetVerificationPage from "./pages/Auth/passwordResetVerificationPage";
import ListingsSearch from "./pages/DashBoard/ListingsSearch/listingsSearch";
import LccExcelUpload from "./pages/Analyst/Dashboard/lccExcelUpload";
import { Banking } from "./pages/Auth/Banking/banking";
import CompanyAdminDashboard from "./pages/Auth/CompanyAdmin/companyAdminDashboard";
import UserProfile from "./pages/Auth/CompanyAdmin/userProfile";
import TraderDashboard from "./pages/Auth/Aggregator/traderDashboard";
import AccountVerification from "./pages/Auth/Registration/Verification/accountVerification";
import LedgerPage from "./pages/Auth/Banking/ledgerPage";
import BankingSearch from "./pages/Auth/Banking/bankingSearch/bankingSearch";
import UserGuide from "./pages/Auth/MyProfile/UserGuide";
const CompanyDetails = React.lazy(() =>
  import(
    /* webpackChunkName: "CompanyDetails"*/ "./pages/Auth/Registration/companyDetails"
  )
);
const RegistrationManager = React.lazy(() =>
  import(
    /* webpackChunkName: "RegistrationManager"*/ "./pages/Auth/Registration/registrationManager"
  )
);

export const routes = [
  {
    path: "/registration_manager",
    element: RegistrationManager,
    ispublic: true,
    isNotAMenu: true,
  },
  { path: "/company_profile", element: CompanyProfile, ispublic: true },
  { path: "/dashboard", element: Dashboard, ispublic: true },
  {
    path: "/landing_cost_calculator",
    element: LandingCostCalculator,
    ispublic: true,
    isNotAMenu: true,
  },
  { path: "/my_documents", element: MyDocuments, ispublic: true },
  // { path: '/capacity_listing', element: CapacityListing, ispublic: true },
  { path: "/edit_profile", element: EditProfile, ispublic: true },
  { path: "/user_guide", element: UserGuide, ispublic: true, isNotAMenu: true },
  { path: "/contact", element: Contact, ispublic: true, isNotAMenu: true },
  { path: "/about_us", element: AboutUs, ispublic: true, isNotAMenu: true },
  { path: "/bids_received", element: BidsReceive, ispublic: true },
  { path: "/consumer_dashboard", element: consumerDashboard, ispublic: true },
  { path: "/faqs", element: Faqs, ispublic: true, isNotAMenu: true },
  { path: "/analyst_dashboard", element: GNAAnalysisDashboard, ispublic: true },
  {
    path: "/analyst_edit_profile",
    element: GNAAnalysisEditProfile,
    ispublic: true,
  },
  { path: "/analyst_registration", element: ViewUserProfile, ispublic: true },
  {
    path: "/analyst_capacity_listing",
    element: GNACapacityListing,
    ispublic: true,
  },
  {
    path: "/verify_your_account",
    element: VerifyYourAccount,
    ispublic: true,
    isNotAMenu: true,
  },
  {
    path: "/otp_verification",
    element: OTPVerification,
    ispublic: true,
    isNotAMenu: true,
  },
  { path: "/capacity_listing", element: CapacityListingNew, ispublic: true },
  {
    path: "/forgotPassword",
    element: ResetPassword,
    ispublic: true,
    isNotAMenu: true,
  },
  {
    path: "/forgotPasswordVerification",
    element: PasswordResetVerificationPage,
    ispublic: true,
    isNotAMenu: true,
  },
  { path: "/search_listings", element: ListingsSearch, ispublic: true },
  { path: "/upload_sheet", element: LccExcelUpload, ispublic: true },
  { path: "/banking", element: Banking, ispublic: true },
  { path: "/bankingRequests_received", element: BidsReceive, ispublic: true },
  {
    path: "/admin_comp_dashboard",
    element: CompanyAdminDashboard,
    ispublic: true,
  },
  {
    path: "/admin_comp_userProfile",
    element: UserProfile,
    ispublic: true,
    isNotAMenu: true,
  },
  { path: "/trader_dashboard", element: TraderDashboard, ispublic: true },
  {
    path: "/account_verification",
    element: AccountVerification,
    ispublic: true,
    isNotAMenu: true,
  },
  { path: "/banking_ledger", element: LedgerPage, ispublic: true },
  { path: "/search_banking", element: BankingSearch, ispublic: true },

  { path: "/", element: Home, ispublic: true, isNotAMenu: true },
  { path: "*", element: UnAuthorizedPage, ispublic: true, isNotAMenu: true },
];

const Routing = () => {
  const token = useSelector((state) => state.sessionState?.token);
  const menuData = useSelector((state) => state.sessionState?.menuData);

  return (
    <Router>
      <Routes>
        {routes.map((rout, index) => {
          return (
            <React.Fragment key={index}>
              {rout.ispublic &&
              (rout?.isNotAMenu ||
                menuData?.find((item) => item?.path === rout?.path)) ? (
                <Route
                  exact
                  path={rout?.path || ""}
                  element={
                    <>
                      <Header />
                      {rout.element && <rout.element />}
                    </>
                  }
                />
              ) : Boolean(token) &&
                menuData?.find((item) => item?.path === rout?.path) ? (
                <Route
                  exact
                  path={rout?.path || ""}
                  element={
                    <>
                      <Header />
                      {rout.element && <rout.element />}
                    </>
                  }
                />
              ) : (
                <Route
                  exact
                  path={rout?.path || ""}
                  element={<UnAuthorizedPage />}
                />
              )}
            </React.Fragment>
          );
        })}
      </Routes>
    </Router>
  );
};
export default Routing;
